import { GetterNames } from './keys'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { SiteDetailedAttributes } from '@/jsonapi/SiteDetailed'
import { SitesDetailedState } from '@/store/modules/site-detailed/types'

export type FlatDetailedSite = FlatAPIData<SiteDetailedAttributes>

export const getters = {
  [GetterNames.detailedSites]: (state: SitesDetailedState): FlatDetailedSite[] => {
    return state && state.detailedSites && state.detailedSites.map(flattenJsonApiResponse)
  },
}
